import type { HeroContent } from "../types";

export function renderHero(hero: HeroContent): string {
  const ctas = hero.ctas
    .map((c) => `<a href="${c.href}" class="btn ${c.variant}">${c.label}</a>`)
    .join("");

  return `
    <section class="hero" id="top">
      <div class="eyebrow" data-reveal>${hero.eyebrow}</div>
      <h1 data-reveal>${hero.titleLead}<span class="accent">${hero.titleAccent}</span></h1>
      <p class="lede" data-reveal>${hero.lede}</p>
      <div class="cta" data-reveal>${ctas}</div>
    </section>`;
}
